ixModuleRouting("impactx.indexqueue", {
    "/indexqueue": {
        templateUrl: "modules/indexqueue/templates/indexqueue.html",
        controller: "IndexQueueCtrl",
        controllerAs: "indexQueueCtrl",
        process: "ViewIndexQueue",
        workspace: "content",
    },
});
